<template>
  <modal
    title="manifest link"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="individual-contaoner">
      <label class="label">Copy link below to share on any platform</label>
      <span class="label text-primary-yellow">This is Manifest for dispatch with Ref No :</span>
      
  <div class="flex">
    <input
    v-model="refId"
    placeholder="--Autoloaded--"
    class="input-field w-full py-2 pl-3 mr-2"
  />
 <img @click="copyRefNo" src="@/assets/images/icons/copy.svg" class="cursor-pointer"/>
  </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    refNo: {
      type: String,
    },
  },

  data() {
    return {
      refId: this.refNo,
    };
  },

  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
   copyRefNo(){
    navigator.clipboard.writeText('This is Manifest for dispatch with Ref No : ' + this.refNo);
    this.generateToast('copied successfully', 'success')
    setTimeout(() => {
      this.closeModal()
    }, 1000);
   }
  },
};
</script>

<style scoped lang="scss">
.label {
  @apply w-full pb-0;
  font-size: 13px;
}
.individual-contaoner {
  @apply w-full p-2 my-0;
}
.filter-search {
  border-radius: 4px;
  @apply py-2;
}
.input-field {
  @apply bg-gray-200;
}
</style>
